import React, { useEffect, useState } from 'react';
import InputRenderer from './InputRenderer';

const FullAddress = ({ t, config, onSelect, formData, errors }) => {
	const inputs = [
		{
			label: "CORE_COMMON_ADDRESS",
			type: "text",
			name: "address",
			validation: {
				isRequired: false,
				// pattern: Digit.Utils.getPattern('Address'),
				// title: t("CORE_COMMON_APPLICANT_ADDRESS_INVALID"),
			}
		}, {
			label: "CORE_COMMON_STATE",
			type: "text",
			name: "state",
			validation: {
				isRequired: false,
				// pattern: Digit.Utils.getPattern('Address'),
				// title: t("CORE_COMMON_APPLICANT_ADDRESS_INVALID"),
			}
		}, {
			label: "CORE_COMMON_DISTRICT",
			type: "text",
			name: "district",
			validation: {
				isRequired: false,
				// pattern: Digit.Utils.getPattern('Address'),
				// title: t("CORE_COMMON_APPLICANT_ADDRESS_INVALID"),
			}
		}, {
			label: "CORE_COMMON_TEHSIL",
			type: "text",
			name: "tehsil",
			validation: {
				isRequired: false,
				// pattern: Digit.Utils.getPattern('Address'),
				// title: t("CORE_COMMON_APPLICANT_ADDRESS_INVALID"),
			}
		}, {
			label: "CORE_COMMON_TOWN",
			type: "text",
			name: "town",
			validation: {
				isRequired: false,
				// pattern: Digit.Utils.getPattern('Address'),
				// title: t("CORE_COMMON_APPLICANT_ADDRESS_INVALID"),
			}
		}, {
			label: "CORE_COMMON_PINNO",
			type: "number",
			name: "pinno",
			validation: {
				isRequired: false,
				// pattern: Digit.Utils.getPattern('Address'),
				// title: t("CORE_COMMON_APPLICANT_ADDRESS_INVALID"),
			}
		},
	];
	const initData = {
		...(inputs.reduce((obj, key) => ({ ...obj, [key.name]: '' }), {})),
	};
	
	const [isPermanentSameAsCorrespondence, setIsPermanentSameAsCorrespondence] = useState(config.key === 'permanentAddress');
	const [addressDetails, setAddressDetails] = useState(
		formData[config.key] || (config.key === 'permanentAddress' ? formData['correspondenceAddress'] : null) || initData
	);
	const [isExpanded, setIsExpanded] = useState(config.key === 'correspondenceAddress');

	const updateAddressDetails = (key, value) => {
		const address = { ...addressDetails }
		address[key] = value;
		setAddressDetails(address);
	};

	const togglePermanentSameAsCorrespondence = () => {
		setIsPermanentSameAsCorrespondence(!isPermanentSameAsCorrespondence);
		if (!isPermanentSameAsCorrespondence) {
			setAddressDetails(formData['correspondenceAddress'] || initData);
		} else {
			setAddressDetails(initData);
		}
	};

	useEffect(() => {
		if (isPermanentSameAsCorrespondence) {
			setAddressDetails(formData['correspondenceAddress'] || initData);
		}
	}, [formData['correspondenceAddress'], isPermanentSameAsCorrespondence]);

	useEffect(() => {
		if (addressDetails) {
			onSelect(config.key, addressDetails);
		}
	}, [addressDetails]);

	return (
		<div style={{ marginBottom: 20, border: '1px solid #d6d5d4', borderRadius: '4px' }}>
			<div 
				onClick={() => setIsExpanded(!isExpanded)} 
				style={{ 
					display: 'flex', 
					justifyContent: 'space-between', 
					alignItems: 'center', 
					padding: '12px 20px', 
					backgroundColor: '#f4f4f4', 
					cursor: 'pointer',
					borderRadius: isExpanded ? '4px 4px 0 0' : '4px'
				}}
			>
				<h3 style={{
					fontSize: 18,
					fontWeight: 'bold',
					margin: 0,
					color: '#0b0c0c'
				}}>{config.title}</h3>
				<span style={{ fontSize: '14px', fontWeight: 'bold' }}>{isExpanded ? '▲' : '▼'}</span>
			</div>
			
			{isExpanded && (
				<div style={{ padding: '20px' }}>
					{config.key === 'permanentAddress' && (
						<label style={{ display: 'flex', alignItems: 'center', gap: 15, marginBottom: 25, cursor: 'pointer' }}>
							<input
								type='checkbox'
								checked={isPermanentSameAsCorrespondence}
								onChange={togglePermanentSameAsCorrespondence}
								style={{ height: 20, width: 20, cursor: 'pointer' }}
							/>
							<span style={{ fontSize: '16px' }}>Is Same as Correspondence Address?</span>
						</label>
					)}
					<InputRenderer {...{ t, config, formData, inputs, errors }} updateInput={updateAddressDetails} />
				</div>
			)}
		</div>
	)
}

export default FullAddress;
